module.exports = __webpack_public_path__ + "static/media/user-icon.d8ffee88.svg";